import { createTheme } from "@mui/material/styles";

export default function themeFile() {
  let customObject = {
    custom: {
      primary: { main: "#008494" },
    },
  };
  return createTheme(customObject);
}
